import { render, staticRenderFns } from "./CollectData.vue?vue&type=template&id=54eb0904&scoped=true&"
import script from "./CollectData.vue?vue&type=script&lang=js&"
export * from "./CollectData.vue?vue&type=script&lang=js&"
import style0 from "./CollectData.vue?vue&type=style&index=0&id=54eb0904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eb0904",
  null
  
)

export default component.exports